export const LogoOlx: {
  name: 'logo_olx-ecdb793504c7'
} = {
  name: 'logo_olx-ecdb793504c7'
}
